import { createContext, useContext, useState, useCallback } from "react";

const translations = {
  es: {
    loginTitle: "Escáner QR",
    loginSubtitle: "Ingresa tu correo para comenzar a escanear",
    emailPlaceholder: "tu@correo.com",
    passwordPlaceholder: "Contraseña",
    enterButton: "Entrar",
    enteringButton: "Ingresando...",
    verifyingSession: "Verificando sesión...",
    emptyEmail: "Ingresa un correo electrónico",
    invalidEmail: "Formato de correo inválido",
    enterPassword: "Ingresa tu contraseña",
    loginError: "Error al iniciar sesión",
    connectionError: "Error de conexión. Intenta de nuevo.",

    headerTitle: "Escáner QR / Barras",
    logout: "Salir",
    validReadings: "Lecturas válidas",
    modeQr: "Código QR",
    modeBarcode: "Código de Barras",
    manualPlaceholder: "Ingresar código manual...",
    addButton: "Agregar",
    initializingScanner: "Inicializando escáner...",
    allowCameraAccess: "Permite el acceso a la cámara cuando se solicite",
    scannerPaused: "Escáner PAUSADO",
    pressNext: 'Presiona "Próximo" para continuar',
    aimBarcode: "Apunta al código de barras",
    aimQr: "Apunta al código QR",
    recentRecords: "Últimos registros",
    deleteButton: "Borrar",
    nextButton: "Próximo",
    repeatButton: "Repetir",
    reviewButton: "Revisar",
    finalizeButton: "Finalizar",
    downloadsButton: "Descargas",
    finalizeModalTitle: "¿Finalizar sesión?",
    totalCodes: "Total de códigos:",
    finalizeModalMessage: "Se generará un archivo CSV con todos los códigos escaneados. ¿Deseas continuar?",
    cancel: "Cancelar",
    yesFinalize: "Sí, finalizar",
    reviewModalTitle: "Revisar códigos",
    selectedCount: "seleccionado(s)",
    markToDelete: "Marca los que deseas eliminar",
    noScannedCodes: "No hay códigos escaneados",
    noSupportVoice: "Tu navegador no soporta dictado por voz",
    errorSavingCode: "Error al guardar el código",
    connErrorScanner: "Error de conexión",
    duplicateCode: "Código duplicado: {code}. Guardado de todos modos.",
    scannedCode: "Código escaneado: {code}",
    enteredCode: "Código ingresado: {code}",
    deletedOne: "Eliminado: {code}",
    repeatedOne: "Repetido: {code}",
    deletedCount: "Eliminados: {count} código(s)",
    noCodesToFinalize: "No hay códigos escaneados para finalizar",
    sessionFinalized: "Sesión finalizada. Archivo: {filename}",
    errorFinalizing: "Error al finalizar la sesión",
    cameraErrorBarcode: "Error al iniciar cámara para códigos de barras",
    cameraErrorQr: "Error al iniciar cámara para QR",

    filesTitle: "Archivos CSV",
    back: "Volver",
    searchPlaceholder: "Buscar archivo...",
    loadingFiles: "Cargando archivos...",
    loadError: "Error al cargar archivos",
    noResults: "Sin resultados",
    noFiles: "No hay archivos CSV disponibles",
    downloaded: "Descargado",
    xlsx: "XLSX",
    csv: "CSV",
    send: "Enviar",
    deleteWord: "Eliminar",
    deleteNotDownloaded: "Este archivo no ha sido descargado aún.",
    deleteModalTitle: "Eliminar archivo",
    areYouSure: "¿Estás seguro?",
    cannotUndo: "Esta acción no se puede deshacer.",
    confirm: "Confirmar",
    yesDelete: "Sí, eliminar",
    deleteErr: "Error al eliminar",
    downloadErr: "Error al descargar",
    sendByEmail: "Enviar por correo",
    emailDestPlaceholder: "correo@destino.com",
    invalidEmailErr: "Ingresa un correo válido",
    sending: "Enviando...",
    sentTo: "Enviado a {email}",
    close: "Cerrar",
    sendErrDefault: "Error al enviar correo",

    selectFormatTitle: "Elige un formato de exportación",
    customColumnsLabel: "Elige las columnas a incluir",
    continueButton: "Continuar",
    backButton: "Atrás",
    reformatTitle: "Re-exportar con formato",
    outputTypeLabel: "Tipo de archivo",
    previewButton: "Vista previa",
    previewTitle: "Vista previa",
    previewRowsShown: "Mostrando {shown} de {total} filas",
    previewEmpty: "Sin datos para mostrar",
  },
  en: {
    loginTitle: "QR Scanner",
    loginSubtitle: "Enter your email to start scanning",
    emailPlaceholder: "you@email.com",
    passwordPlaceholder: "Password",
    enterButton: "Enter",
    enteringButton: "Signing in...",
    verifyingSession: "Verifying session...",
    emptyEmail: "Enter an email address",
    invalidEmail: "Invalid email format",
    enterPassword: "Enter your password",
    loginError: "Login error",
    connectionError: "Connection error. Try again.",

    headerTitle: "QR / Barcode Scanner",
    logout: "Log out",
    validReadings: "Valid readings",
    modeQr: "QR Code",
    modeBarcode: "Barcode",
    manualPlaceholder: "Enter manual code...",
    addButton: "Add",
    initializingScanner: "Initializing scanner...",
    allowCameraAccess: "Allow camera access when prompted",
    scannerPaused: "Scanner PAUSED",
    pressNext: 'Press "Next" to continue',
    aimBarcode: "Aim at the barcode",
    aimQr: "Aim at the QR code",
    recentRecords: "Recent records",
    deleteButton: "Delete",
    nextButton: "Next",
    repeatButton: "Repeat",
    reviewButton: "Review",
    finalizeButton: "Finish",
    downloadsButton: "Downloads",
    finalizeModalTitle: "Finish session?",
    totalCodes: "Total codes:",
    finalizeModalMessage: "A CSV file will be generated with all scanned codes. Do you want to continue?",
    cancel: "Cancel",
    yesFinalize: "Yes, finish",
    reviewModalTitle: "Review codes",
    selectedCount: "selected",
    markToDelete: "Mark the ones you want to delete",
    noScannedCodes: "No scanned codes",
    noSupportVoice: "Your browser doesn't support voice dictation",
    errorSavingCode: "Error saving code",
    connErrorScanner: "Connection error",
    duplicateCode: "Duplicate code: {code}. Saved anyway.",
    scannedCode: "Code scanned: {code}",
    enteredCode: "Code entered: {code}",
    deletedOne: "Deleted: {code}",
    repeatedOne: "Repeated: {code}",
    deletedCount: "Deleted: {count} code(s)",
    noCodesToFinalize: "No scanned codes to finish",
    sessionFinalized: "Session finished. File: {filename}",
    errorFinalizing: "Error finishing session",
    cameraErrorBarcode: "Error starting camera for barcodes",
    cameraErrorQr: "Error starting camera for QR",

    filesTitle: "CSV Files",
    back: "Back",
    searchPlaceholder: "Search file...",
    loadingFiles: "Loading files...",
    loadError: "Error loading files",
    noResults: "No results",
    noFiles: "No CSV files available",
    downloaded: "Downloaded",
    xlsx: "XLSX",
    csv: "CSV",
    send: "Send",
    deleteWord: "Delete",
    deleteNotDownloaded: "This file hasn't been downloaded yet.",
    deleteModalTitle: "Delete file",
    areYouSure: "Are you sure?",
    cannotUndo: "This action cannot be undone.",
    confirm: "Confirm",
    yesDelete: "Yes, delete",
    deleteErr: "Error deleting",
    downloadErr: "Error downloading",
    sendByEmail: "Send by email",
    emailDestPlaceholder: "recipient@email.com",
    invalidEmailErr: "Enter a valid email",
    sending: "Sending...",
    sentTo: "Sent to {email}",
    close: "Close",
    sendErrDefault: "Error sending email",

    selectFormatTitle: "Choose an export format",
    customColumnsLabel: "Choose the columns to include",
    continueButton: "Continue",
    backButton: "Back",
    reformatTitle: "Re-export with format",
    outputTypeLabel: "File type",
    previewButton: "Preview",
    previewTitle: "Preview",
    previewRowsShown: "Showing {shown} of {total} rows",
    previewEmpty: "No data to show",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("qre_lang") || "es");

  const setLang = useCallback((newLang) => {
    localStorage.setItem("qre_lang", newLang);
    setLangState(newLang);
  }, []);

  const t = useCallback((key, vars) => {
    let text = translations[lang][key] || translations.es[key] || key;
    if (vars) {
      Object.keys(vars).forEach((k) => {
        text = text.replace(`{${k}}`, vars[k]);
      });
    }
    return text;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
